import { ComponentType } from "../../data";
import { ComponentTypeMapper } from "../ComponentTypeMapper";
import { EventsBySportIdRequest } from "sb-bff-integration";
export const mapEventComponent = (event, cardConfig, isMini) => {
    const cardConfiguration = cardConfig.getConfig(isMini);
    let currentSportId = cardConfiguration[event.sportId] ? event.sportId : "0";
    event.componentType = getComponentType(event, isMini);
    if (event.type === EventsBySportIdRequest.EventTypesEnum.Fixture.toString()) {
        let cardType = cardConfiguration[currentSportId].cardType;
        event.cardType = cardType;
    }
    return event;
};
const getComponentType = (event, isMiniCard) => {
    return ComponentTypeMapper[event.type] ? ComponentTypeMapper[event.type](isMiniCard, event.isLive) : ComponentType.EventCard;
};
//# sourceMappingURL=mapEventComponent.js.map